import React from 'react';

const CheckoutContext = React.createContext({});

const CheckoutProvider = ({ children }: React.PropsWithChildren) => {
  return <CheckoutContext.Provider value={{}}>{children}</CheckoutContext.Provider>;
};

export default CheckoutProvider;
